/// <reference path="../../../typings/tsd.d.ts" />

module warsApp.directives {
    export interface IManageCommentThreadScope extends ng.IScope {
        manageSection: Wars.Domain.Model.ManageSection;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        isConfigureMode: boolean;
        isEditMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        addingNewComment: boolean;
        newComment: string;
        newCommentDocIds: string[];
        newCommentDate:any;
        saveNewComment: () => void;
        addNewComment: () => void;
        cancelNewComment: () => void;
        documentUpdated: (model: models.FileUploadModel) => void;
    }

    export class ManageCommentThread implements IDirective {
        public link($scope: IManageCommentThreadScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/manageForm/manageCommentThread.html";
        public controller = [
            "$scope", "commentService",  "processDocumentService", ManageCommentThreadController
        ];
        public controllerAs = "controller";
        public restrict: string = "E";
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            manageSection: "=",
            process: "=",
            processConfiguration: "=",
            processConfigurationId: "="
        };
    }

    export class ManageCommentThreadController {

        constructor(
            private scope: IManageCommentThreadScope,
            private commentService: services.CommentService,
            private processDocumentService: services.ProcessDocumentService)
        {
            scope.newCommentDate = {d:null};
            scope.saveNewComment = () => this.saveNewComment();
            scope.addNewComment = () => this.addNewComment();
            scope.cancelNewComment = () => this.cancelNewComment();
            scope.documentUpdated = (model: models.FileUploadModel) => this.documentUpdatedInternal(model);
        }

        private addNewComment(): void {
            this.scope.addingNewComment = true;
            this.scope.newComment = undefined;
            this.scope.newCommentDocIds = [];
            this.scope.newCommentDate = { d: null };
        }

        private saveNewComment(): void {
            this.scope.addingNewComment = false;

            var commentDate = null;

            if (this.scope.manageSection.commentThreadConfiguration.allowCommentDateToBeSet) {
                commentDate = this.scope.newCommentDate ? this.scope.newCommentDate.d : undefined;
            }

            var commentDto: Wars.Domain.Model.Dtos.CommentDto = {
                comment: this.scope.newComment,
                documentIds: this.scope.newCommentDocIds,
                processId: this.scope.process.id,
                manageSectionUniqueId: this.scope.manageSection.uniqueIdentifier,
                commentDate: commentDate
            };

            this.commentService.createNewCommentThreadEntry(commentDto).then(
                (commentThread) => {
                    if (this.scope.newCommentDocIds && this.scope.process) {
                        this.processDocumentService.updateManageDocumentSections(this.scope.process);
                    }

                    this.scope.addingNewComment = false;
                    this.scope.newComment = undefined;
                    this.scope.newCommentDate = { d: null };
                    this.scope.newCommentDocIds = [];

                    if (!this.scope.process.commentThreads[this.scope.manageSection.uniqueIdentifier].threads) {
                        this.scope.process.commentThreads[this.scope.manageSection.uniqueIdentifier].threads = [];
                    }

                    this.scope.process.commentThreads[this.scope.manageSection.uniqueIdentifier].threads.push(commentThread);
                });
        }

        private cancelNewComment(): void {
            this.scope.newComment = undefined;
            this.scope.addingNewComment = false;
        }

        private documentUpdatedInternal(model: models.FileUploadModel): void {
            this.scope.newCommentDocIds = Enumerable.from(model.documents).select(i => i.id).toArray();
        }
    }
}

warsApp.registerDirective('ManageCommentThread', []);